import axios from 'axios';
import { AuthService } from "./services/auth-service";
import { apiUrl } from "./config.js"

const authService = new AuthService();

const getConfig = () => {
    return {
        headers: {
            'Authorization': `bearer ${localStorage.getItem("token")}`
        }
    };
};

const getCustomerId = () => {
    return authService.getUserData(AuthService.CUSTOMER_ID_KEY);
};

const get = (url) => {
    return axios.get(`${apiUrl}/${url}`, getConfig())
        .catch(checkForUnauthorised)
};

const post = (url, payload) => {
    return axios.post(`${apiUrl}/${url}`, payload || getConfig())
        .catch(checkForUnauthorised)
}

const postPromise = (url, payload) => {

    return new Promise(function (resolve, reject) {

            const request = new XMLHttpRequest();
    
            request.open('POST', `${apiUrl}/${url}`);
            request.setRequestHeader(
                'Authorization', `bearer ${localStorage.getItem("token")}`);
    
            request.onload = function (d) {
    
                if (request.status === 200) {
                   
                    var responseText = JSON.parse(request.response)
                    resolve(responseText);
    
                } else {
                    reject(request.statusText);
                }
            }
    
            request.send(payload);
        });
};

const postform = (url, formData) => {


    return new Promise(function (resolve, reject) {

        const request = new XMLHttpRequest();

        request.open('POST', `${apiUrl}/${url}`);
        request.setRequestHeader(
            'Authorization', `bearer ${localStorage.getItem("token")}`);

        request.onload = function (d) {

            if (request.status === 200) {
               
                var responseText = JSON.parse(request.response)
                resolve(responseText);

            } else {
                reject(request.statusText);
            }
        }

        request.send(formData);
    });

};

const checkForUnauthorised = (error) => {
    if (error.response && error.response.status === 401) { resetAuth(); }

    throw error;
};

const resetAuth = () => {
    authService.clearUserCache();
    window.location.href = "/";
};

export const getCustomerList = () => {
    return get(`Customer/List`)
        .then(({ data }) => data)
};

export const getCustomerUserList = (customerId, query) => {
    return get(`Customer/UserList/${customerId}?${query}`)
        .then(({ data }) => data)
};


export const getWasteDetail = (wasteId) => {
    return get(`Waste/Detail/${wasteId}`)
        .then(({ data }) => data);
};

export const getWasteList = (customerId, query) => {
    return get(`Waste/List/${customerId}?${query}`)
        .then(({ data }) => data);
};

export const getWasteSubmissionCountByContainer = (customerId) => {
    return post(`Waste/SubmissionCountByContainer?customerId=${customerId}`)
        .then(({ data }) => data);
};

export const getWasteSubmissionCountByDestination = (customerId) => {
    return post(`Waste/SubmissionCountByDestination?customerId=${customerId}`)
        .then(({ data }) => data);
};

export const getWasteSubmissionCountByStream = (customerId) => {
    return post(`Waste/SubmissionCountByStream?customerId=${customerId}`)
        .then(({ data }) => data);
};

export const getMonthlyCostConsumption = () => {
    return get(`Customer/CostConsumption/Monthly/${getCustomerId()}`)
        .then(({ data }) => data);
};

export const getToken = (userInfo) => {
    return post(`Auth/Login`, userInfo)
        .then(({ data }) => data);
};


export const updateClient = (clientId) => {
    return get(`Auth/UpdateClient/${clientId}`)
        .then(({ data }) => data);
};

export const updateUserPolicyReadAccepted = () => {
    return get(`Auth/UpdateUserPolicyReadAccepted`)
        .then(({ data }) => data);
};

export const getCustomerConsumption = (customerId, siteBreakdown) => {
    return get(`Customer/CostConsumption/${customerId}?siteBreakdown=${siteBreakdown}`)
        .then(({ data }) => data);
};



export const getSitesCostConsumption = (customerId, siteId) => {
    return get(`Sites/CostConsumption/${customerId}/${siteId}`)
        .then(({ data }) => data);
};

export const getSitesContacts = (customerId, siteId, query) => {
    return get(`Sites/Contacts/${customerId}/${siteId}?${query}`)
        .then(({ data }) => data);
};

export const getDataCompletenessByUtility = () => {
    return get(`Sites/DataCompletenessByUtility/${getCustomerId()}`)
        .then(({ data }) => data);
};

export const getSitesDetail = (siteId) => {
    return get(`Sites/Detail/${siteId}`)
        .then(({ data }) => data);
};

export const getMeterDetail = (customerId, siteId, meterId) => {
    return get(`Meters/MeterDetails/${customerId}/${siteId}/${meterId}`)
        .then(({ data }) => data[0]);
};



export const getMeterReadLookup = (customerId, meterId) => {
    return get(`MeterReads/MeterReadLookup/${customerId}/${meterId}`)
        .then(({ data }) => data);
};


export const getMetersCount = (customerId) => {
    return get(`Meters/MeterSiteCount/${customerId}`)
        .then(({ data }) => data);
};

export const getMetersCountBySite = (customerId, siteId) => {
    return get(`Meters/MeterSiteCount/${customerId}/${siteId}`)
        .then(({ data }) => data);
};

export const getSitesDocuments = (siteId) => {
    return get(`Sites/Documents/${siteId}`)
        .then(({ data }) => data);
};

export const getSitesExceptions = (siteId) => {
    return get(`Sites/Exceptions/${siteId}`)
        .then(({ data }) => data);
};

export const getSitesHalfHour = (siteId) => {
    return get(`Sites/HalfHour/${siteId}`)
        .then(({ data }) => data);
};

export const getSitesList = (customerId, query) => {
    return get(`Sites/List/${customerId}?` + query)
        .then(({ data }) => data);
};

export const getQueryListQuery = (customerId, query) => {
    return get(`ServiceManagement/CasesSummary/${customerId}?${query}`)
        .then(({ data }) => data);
};

export const getCaseList = (customerId, siteKey, metersiteKey, filterNetSaving,  query) => {

    return get(`ServiceManagement/Cases/List/${customerId}/${siteKey}/${metersiteKey}/${filterNetSaving}?${query}`)
        .then(({ data }) => data);
};

export const getClientDetails = (customerId) => {
    return get(`Customer/ClientDetails/${customerId}`)
        .then(({ data }) => data);
};

export const getSiteList = () => {
    return get(`Sites/List/${getCustomerId()}`)
        .then(({ data }) => data);
};

export const getMetersList = (customerId) => {
    return get(`Meters/List/${customerId}`)
        .then(({ data }) => data.data);
};

export const getSitesMeters = (customerId, siteId, query) => {
    return get(`Meters/List/${customerId}/${siteId}?` + query)
        .then(({ data }) => {
            return data;
        })
};

//COTS

export const getCotsClients = () => {
    return get(`Customer/CotsClients`)
        .then(({ data }) => data);
};

export const getFullCotsClients = () => {
    return get(`Customer/FullCotsClients`)
        .then(({ data }) => data);
};

export const addCotsClient = (clientId, clientName) => {
    return postPromise(`Customer/AddCotsClient/${clientId}/${clientName}`)
        .then(({ data }) => data);
};

export const removeCotsClient = (clientId) => {
    return postPromise(`Customer/RemoveCotsClient/${clientId}`)
        .then(({ data }) => data);
};

export const addFullCotsClient = (clientId, clientName) => {
    return postPromise(`Customer/AddFullCotsClient/${clientId}/${clientName}`)
        .then(({ data }) => data);
};

export const removeFullCotsClient = (clientId) => {
    return postPromise(`Customer/RemoveFullCotsClient/${clientId}`)
        .then(({ data }) => data);
};




export const getCustomerMeters = (customerId, query) => {
    return get(`Meters/List/${customerId}?` + query)
        .then(({ data }) => {
            return data;
        })
};



export const getUtilityMeters = (MeterId) => {

    return get(`Meters/UtilityMeterDetails/${MeterId}`)
        .then(({ data }) => data)
};

export const getSitesQsr = (siteId) => {
    return get(`Sites/QsrCommentary/${siteId}`)
        .then(({ data }) => data)
};

export const getSitesSupplierInvoices = (customerId, siteId, query) => {
    return get(`Sites/SupplierInvoices/${customerId}/${siteId}?${query}`)
        .then(({ data }) => data)
};

export const getMeterSupplierInvoices = (customerId, siteId, meterId, query) => {
    return get(`Meters/SupplierInvoices/${customerId}/${siteId}/${meterId}?${query}`)
        .then(({ data }) => data)
};

export const getSupplierInvoicesList = (customerId, query) => {
    return get(`SupplierInvoices/List/${customerId}?${query}`)
        .then(({ data }) => data)
};

export const getSpecificSupplierInvoice = (customerId, supplierInvoiceId) => {
    return get(`SupplierInvoices/Specific/${customerId}/${supplierInvoiceId}`)
        .then(({ data }) => data)
};

export const getSupplierInvoiceDetails = (supplierInvoiceId) => {
    return get(`SupplierInvoices/Detail/${supplierInvoiceId}`)
        .then(({ data }) => data)
};

export const getSupplierInvoiceReadings = (supplierInvoiceId) => {
    return get(`SupplierInvoices/Readings/${supplierInvoiceId}`)
        .then(({ data }) => data)
};

export const getSupplierInvoicesCountByUtility = (customerId) => {
    return get(`SupplierInvoices/CountByUtility/${customerId}`)
        .then(({ data }) => data)
};

export const getSupplierInvoicesCountByUtilityPerMonth = (customerId) => {
    return get(`SupplierInvoices/UtilityByMonth/${customerId}`)
        .then(({ data }) => data)
};

export const getSitesWaste = (siteId) => {
    return get(`Sites/Waste/${siteId}`)
        .then(({ data }) => data)
};

export const getMetersByUtility = (customerId) => {
    return get(`Meters/ByUtility/${customerId}`)
        .then(({ data }) => data)
};

export const getMeterCountByCounty = (customerId) => {
    return get(`Meters/CountByCounty/${customerId}`)
        .then(({ data }) => data)
};

export const getMeterConsumption = (customerId, siteId, meterId) => {
    return get(`Meters/CostConsumption/${customerId}/${siteId}/${meterId}`)
        .then(({ data }) => data)
};

export const getMetersReadCountByUtility = (customerId) => {
    return get(`Meters/ReadCountByUtility/${customerId}`)
        .then(({ data }) => data)
};

export const getQueryList = (customerId) => {
    return get(`ServiceManagement/CasesSummary/${customerId}`)
        .then(({ data }) => data.data)
};

export const getQueryDetail = (caseId) => {
    return get(`ServiceManagement/CaseDetail/${caseId}`)
        .then(({ data }) => data)
};

export const getCaseKPI = (caseId) => {
    return get(`ServiceManagement/CasesKPI/${caseId}`)
        .then(({ data }) => data)
};

export const getHalfHourReadings = (customerId, query) => {
    return get(`HalfHour/List/${customerId}?${query}`)
        .then(({ data }) => data);
};
export const getHalfHourSiteReadings = (customerId, siteId, query) => {
    return get(`HalfHour/List/${customerId}/${siteId}?${query}`)
        .then(({ data }) => data);
};
export const getHalfHourMeterReadings = (customerId, siteId, meterId, query) => {
    return get(`Meters/HalfHour/${customerId}/${siteId}/${meterId}?${query}`)
        .then(({ data }) => data);
};

export const getBudgetsList = (customerId, query) => {
    return get(`Budgets/List/${customerId}?${query}`)
        .then(({ data }) => data);
};

export const getTriggersList = (customerId, query) => {
    return get(`Triggers/List/${customerId}?${query}`)
        .then(({ data }) => data);
};

export const getContractsList = (customerId, query) => {
    return get(`Contracts/List/${customerId}?${query}`)
        .then(({ data }) => data);
};

export const getContractVolumeList = (customerId, contractId, query) => {
    return get(`Contracts/Volumes/${customerId}/${contractId}?${query}`)
        .then(({ data }) => data);
};

export const getContractTradeList = (customerId, contractId, query) => {
    return get(`Contracts/Trades/${customerId}/${contractId}?${query}`)
        .then(({ data }) => data);
};

export const getContractTradingStrategiesList = (customerId, contractId, query) => {
    return get(`Contracts/TradingStrategies/${customerId}/${contractId}?${query}`)
        .then(({ data }) => data);
};

export const resetPassword = (emailAddress) => {
    const urlPattern = `${window.location.origin}/password-reset/{TOKEN}`;
    return post(`PasswordReset/Request`, { emailAddress: emailAddress, responseUrlPattern: urlPattern })
        .then(({ data }) => data);
};

export const changePassword = (token, newPassword) => {
    return post(`PasswordReset/Change`, { token, newPassword })
        .then(({ data }) => data);
};

export const getClosingPriceList = (fromDate, toDate) => {
    const queryString = `fromDate=${encodeURI(fromDate || "")}&toDate=${encodeURI(toDate || "")}`;
    return get(`ClosingPrice/List?${queryString}`)
        .then(({ data }) => data);
};

export const getDocuments = (customerId, query) => {
    return get(`Documents/List/${customerId}?` + query)
        .then(({ data }) => data);
};

export const getVideoGuideList = () => {
    return get(`VideoGuide/GetList`)
        .then(({ data }) => data);
};



export const addRelease = (formData) => {
    return postform(`Info/AddRelease/`, formData)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })

        
}


export const getVideoGuides = () => {
    return get(`VideoGuide/GetList`) // Endpoint for getting the list of video guides
        .then(({ data }) => data);
};

export const addVideoGuide = (videoGuide) => {
    return postform(`VideoGuide/AddGuide`, videoGuide) // Endpoint for adding a new video guide
        .then(({ data }) => data);
};

export const deleteVideoGuide = (videoId) => {
    return postform(`VideoGuide/DeleteGuide/${videoId}`) // Endpoint for deleting a video guide
        .then(({ data }) => data);
};

export const getReleases = () => {
    return get(`Info/GetReleases/`)
        .then(({ data }) => data);
};

export const getDataMapsList = (query) => {
    return get(`DataMaps/List?` + query)
        .then(({ data }) => data);
};

export const getAllDataMapsList = (query) => {
    return get(`DataMaps/AllMaps?` + query)
        .then(({ data }) => data);
};

export const getMapData = (query) => {
    return get(`DataMaps/GetMapData?` + query)
        .then(({ data }) => data);
};

export const NewDataMapUserDetails = (mapId, username) => {
    return get(`DataMaps/AddMapUser/${mapId}/${username}`)
        .then(({ data }) => data);
};

export const DeleteMapUser = (mapId, username) => {
    return get(`DataMaps/DeleteMapUser/${mapId}/${username}`)
        .then(({ data }) => data);
};

export const getMapUserList = (mapSource) => {
    return get(`DataMaps/GetMapUserList/${mapSource}`)
        .then(({ data }) => data);
};



export const MeterReadVerifySubmit = (customerId, siteId, meterId, utilityMeterKey, formData) => {
    return postform(`MeterReads/MeterReadVerifySubmit/${customerId}/${siteId}/${meterId}/${utilityMeterKey}`, formData)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })

};

export const getEnvironmentCommetary = (customerId, siteId, query) => {
    return get(`EnvironmentalCommentary/EnvironmentalCommentary/${siteId}?` + query)
        .then(({ data }) => {
            return data;
        })
};

export const postEnvironmentalCommentary = (formData) => {
    return postform(`EnvironmentalCommentary/SaveEnvironmentalCommentary/`, formData)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })

}
export const ProductionParameter_Update = (formData) => {
    return postform(`ProductionParameter/UpdateProductionParameter`, formData)
        .then(({ data }) => data);
};

export const getProductionParameterDetail = (siteId, query) => {
    return get(`ProductionParameter/ProductionParameter/${siteId}?` + query)
        .then(({ data }) => {
            return data;
        })
};

export const getQsrCommentary = (customerId, siteId, query) => {
    return get(`LogQSR/GetLogQSRList/${siteId}?` + query)
        .then(({ data }) => {
            return data;
        })
};



export const getAreaOrEventTypes = (areaOrEventType) => {

    return postform(`LogQSR/GetAreaOrEventTypes?areaOrEventType=${areaOrEventType}`)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })

}


export const postQsrCommentary = (formData) => {
    return postform(`LogQSR/SaveLogQSR`, formData)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })

}

export const GetLogSiteUpdate = (queueId) => {
    return get(`ServiceManagement/GetLogSiteUpdate/${queueId}`)
        .then(({ data }) => {
            return data;
        })
};

export const GetLogNewSite = (queueId) => {
    return get(`ServiceManagement/GetLogNewSite/${queueId}`)
        .then(({ data }) => {
            return data;
        })
};

export const DeleteLogNewSite = (queueId) => {
    return get(`ServiceManagement/DeleteLogNewSite/${queueId}`)
        .then(({ data }) => {
            return data;
        })
};

export const DeleteLogSiteUpdate = (queueId) => {
    return get(`ServiceManagement/DeleteLogSiteUpdate/${queueId}`)
        .then(({ data }) => {
            return data;
        })
};

export const postAddCotRequest = (formData) => {

    return postform(`ServiceManagement/LogNewSite`, formData)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })

}

export const postSubmitCaseUpdate = (formData) => {

    return postform(`ServiceManagement/SubmitCaseUpdate`, formData)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })

}

export const postSubmitNewCase = (formData) => {

    return postform(`ServiceManagement/SubmitNewCase`, formData)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })

}


export const postPauseCotRequest = (formData) => {

    return postform(`ServiceManagement/PauseLogNewSite`, formData)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })

}

export const postPauseUpdateSiteRequest = (formData) => {

    return postform(`ServiceManagement/PauseLogUpdateSite`, formData)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })

}

export const postUpdateSiteRequest = (formData) => {

    return postform(`ServiceManagement/LogSiteUpdate`, formData)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })

}

export const postNewUserDetails = (formData) => {

    return postform(`Auth/CreateUser`, formData)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })

}
export const updateUser = (userId, formData) => {

    return postform(`Auth/UpdateUser/${userId}`, formData)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })

}



export const getRolesList = (customerId, query) => {
    return get(`Auth/GetRolesList/${customerId}?${query}`)
        .then(({ data }) => data)
};

export const getFundList = () => {
    return get(`Auth/GetFundList`)
        .then(({ data }) => data)
};

export const getUserSites = (userId) => {
    return get(`Auth/GetUserSites/${userId}`)
        .then(({ data }) => data)
}
export const getUserClient = (userId) => {
    return get(`Auth/GetUserClient/${userId}`)
        .then(({ data }) => data)
}
export const getUserFund = (userId) => {
    return get(`Auth/GetUserFund/${userId}`)
        .then(({ data }) => data)
}
export const getUserSubRoles = (userId) => {
    return get(`Auth/GetUserRoles/${userId}`)
        .then(({ data }) => data)
}

export const getJLLPAMSites = (emailAddress) => {
    return get(`Auth/GetJLLPAMSites/${emailAddress}`)
        .then(({ data }) => data)
}

export const resyncJLLPAMSites = (emailAddress) => {
    return get(`Auth/ResyncJLLPAMSites/${emailAddress}`)
        .then(({ data }) => data)
}



export const addUserSites = (userId, siteId) => {
    return postform(`Auth/AddUserSite/${userId}/${siteId}`)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })
}
export const addUserClient = (userId, clientId, clientName) => {

    return postform(`Auth/AddUserClient/${userId}/${clientId}/${clientName}`)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })
}

export const addUserFund = (userId, fundName) => {
    return postform(`Auth/AddUserFund/${userId}/${fundName}`)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })
}

export const addUserSubRoles = (userId, roleId) => {
    return postform(`Auth/AddUserRole/${userId}/${roleId}`)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })
}


export const removeUserSites = (userId, siteId) => {
    return postform(`Auth/RemoveUserSite/${userId}/${siteId}`)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })
}

export const removeUserClient = (userId, clientId) => {
    return postform(`Auth/RemoveUserClient/${userId}/${clientId}`)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })
}

export const removeUserFund = (userId, fundName) => {
    return postform(`Auth/RemoveUserFund/${userId}/${fundName}`)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })
}

export const removeUserSubRoles = (userId, roleId) => {
    return postform(`Auth/RemoveUserRole/${userId}/${roleId}`)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })
}


export const resetUserPassword = (userId) => {
    return postform(`Auth/IssuePassword/${userId}`)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })
}

export const deleteUser = (userId) => {
    return postform(`Auth/DeleteUser/${userId}`)
        .catch(function (error) { // (*)

            return Promise.reject(error);

        }).then(function (result) {
            return Promise.resolve(result);
        })
}

export const getFieldMapping = (customerId) => {
    return get(`Sites/GetFieldMapping/${customerId}`)
        .then(( data ) => data)
}
